import { gql } from "@apollo/client";

export const PROGRAMMING_SESSIONS_CRUD = gql`
  mutation ProgrammingSessionsCrud($originId: ID!, $scenarioId: ID!, $input: SessionCrudInput!) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      sessionsCrud(input: $input) {
        skippedValidations
        commited
        userCanSkipValidations
        payload {
          updates {
            sessionId
            sessionUuid
            intervalValidationErrors {
              interval {
                id
                startingDate
                endingDate
                __typename
              }
              validationErrors {
                ... on InvalidBlock {
                  __typename
                  isValidStartTime
                  isValidEndTime
                }
                ... on BookingClassroomClash {
                  __typename
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  classroom {
                    id
                    code
                    __typename
                  }
                }
                ... on ClassroomClash {
                  __typename
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  classroom {
                    id
                    code
                    __typename
                  }
                }
                ... on InstructorClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  instructor {
                    id
                    code
                    __typename
                  }
                }
                ... on LinkClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  link {
                    id
                    vacancies
                    __typename
                  }
                }
                ... on PackageClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  package {
                    id
                    code
                    index
                    complete
                    vacancies
                    hasPackageRules
                    type
                    __typename
                  }
                }
                ... on InvalidInstructorTravel {
                  __typename
                  instructor {
                    id
                    name
                    __typename
                  }
                  withPrevious {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                  withFollowing {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                }
                ... on InvalidPackageTravel {
                  __typename
                  package {
                    id
                    code
                    __typename
                  }
                  withPrevious {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                  withFollowing {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                }
                ... on InvalidBlockForInstructor {
                  instructor {
                    code
                    __typename
                  }
                  __typename
                }
                ... on InstructorExceededWeeklyBlocks {
                  instructor {
                    code
                    __typename
                  }
                  assignableBlocks
                  exceededBlocks
                  __typename
                }
                __typename
              }
              __typename
            }
            customValidations {
              __typename
              code
              info {
                ... on InstructorInfo {
                  __typename
                  instructor {
                    code
                    __typename
                  }
                }
                __typename
              }
              items {
                key
                value
                __typename
              }
            }
            validationErrors {
              ... on InvalidExpectedBlocksByLink {
                allowed
                weeklyBlocks
                numberOfWeeks
                totalBlocks
                programmedBlocks
                __typename
              }
              ... on InvalidTotalExpectedBlocksByLink {
                allowed
                programmedBlocks
                expectedBlocks
                difference
                __typename
              }
              ... on ExternalGroupValidation {
                allowed
                rejected_groups
                __typename
              }
              ... on InstructorAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on ClassroomsAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on IntervalsAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on BlocksAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on InvalidClassroomsCapacityAssignment {
                allowed
                __typename
              }
              ... on InvalidPastSessionEdition {
                allowed
                intervals {
                  id
                  name
                  startingDate
                  endingDate
                  __typename
                }
                __typename
              }
              ... on InvalidSessionInHoliday {
                holiday {
                  id
                  name
                  date
                  __typename
                }
                allowed
                __typename
              }
              ... on StudentClash {
                __typename
                count
                students {
                  id
                  code
                  __typename
                }
              }
              __typename
            }
            __typename
          }
          creates {
            sessionId
            sessionUuid
            intervalValidationErrors {
              interval {
                id
                startingDate
                endingDate
                __typename
              }
              validationErrors {
                ... on InvalidBlock {
                  __typename
                  isValidStartTime
                  isValidEndTime
                }
                ... on BookingClassroomClash {
                  __typename
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  classroom {
                    id
                    code
                    __typename
                  }
                }
                ... on ClassroomClash {
                  __typename
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  classroom {
                    id
                    code
                    __typename
                  }
                }
                ... on InstructorClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  instructor {
                    id
                    code
                    __typename
                  }
                }
                ... on LinkClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    name
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  link {
                    id
                    vacancies
                    __typename
                  }
                }
                ... on PackageClash {
                  __typename
                  block {
                    startingTime
                    endingTime
                    __typename
                  }
                  interval {
                    startingDate
                    endingDate
                    __typename
                  }
                  sessions {
                    id
                    section {
                      id
                      __typename
                    }
                    __typename
                  }
                  package {
                    id
                    code
                    index
                    complete
                    vacancies
                    hasPackageRules
                    type
                    __typename
                  }
                }
                ... on InvalidInstructorTravel {
                  __typename
                  instructor {
                    id
                    name
                    __typename
                  }
                  withPrevious {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                  withFollowing {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                }
                ... on InvalidPackageTravel {
                  __typename
                  package {
                    id
                    code
                    __typename
                  }
                  withPrevious {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                  withFollowing {
                    from {
                      id
                      vacancies
                      __typename
                    }
                    to {
                      id
                      vacancies
                      __typename
                    }
                    blocksBetween
                    blocksRequired
                    __typename
                  }
                }
                ... on InvalidBlockForInstructor {
                  instructor {
                    code
                    __typename
                  }
                  __typename
                }
                ... on InstructorExceededWeeklyBlocks {
                  instructor {
                    code
                    __typename
                  }
                  assignableBlocks
                  exceededBlocks
                  __typename
                }
                __typename
              }
              __typename
            }
            customValidations {
              __typename
              code
              info {
                ... on InstructorInfo {
                  __typename
                  instructor {
                    code
                    __typename
                  }
                }
                __typename
              }
              items {
                key
                value
                __typename
              }
            }
            validationErrors {
              ... on InvalidExpectedBlocksByLink {
                allowed
                weeklyBlocks
                numberOfWeeks
                totalBlocks
                programmedBlocks
                __typename
              }
              ... on InvalidTotalExpectedBlocksByLink {
                allowed
                programmedBlocks
                expectedBlocks
                difference
                __typename
              }
              ... on ExternalGroupValidation {
                allowed
                rejected_groups
                __typename
              }
              ... on InstructorAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on ClassroomsAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on IntervalsAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on BlocksAssignmentNotAllowed {
                allowed
                __typename
              }
              ... on InvalidClassroomsCapacityAssignment {
                allowed
                __typename
              }
              ... on InvalidPastSessionEdition {
                allowed
                intervals {
                  id
                  name
                  startingDate
                  endingDate
                  __typename
                }
                __typename
              }
              ... on InvalidSessionInHoliday {
                holiday {
                  id
                  name
                  date
                  __typename
                }
                allowed
                __typename
              }
              ... on StudentClash {
                __typename
                count
                students {
                  id
                  code
                  __typename
                }
              }
              __typename
            }
            __typename
          }
          deletes {
            sessionId
            sessionUuid
            validationErrors {
              ... on InvalidPastSessionEdition {
                allowed
                intervals {
                  id
                  name
                  startingDate
                  endingDate
                  __typename
                }
                __typename
              }
              ... on InvalidTotalExpectedBlocksByLink {
                allowed
                programmedBlocks
                expectedBlocks
                difference
                __typename
              }
              __typename
            }
            __typename
          }
          __typename
        }
        __typename
      }
      __typename
    }
  }
`;
